import React, { Component } from 'react';
import { connect } from 'react-redux';
import FirmwaresActions from '../../redux/FirmwaresRedux';
import PageWithTable from '../../components/PageWithTable';
import { withTranslation } from 'react-i18next';
import DictionariesActions from '../../redux/DictionariesRedux';
import Lozenge from '@atlaskit/lozenge';
import Tooltip from '@atlaskit/tooltip';

const statusMap = {
  "Активна": "success",
  "Не активна": "removed"
};


const columns = t => ([
    {
        key: 'id',
        dataKey: 'id',
        title: t('Id'),
        sortable: true,
        minWidth: 20,
        width: 20,
        flexGrow: 1,
    },
    {
      key: 'name',
      dataKey: 'name',
      title: t('Name'),
      sortable: true,
      minWidth: 150,
      width: 150,
      flexGrow: 1,
      cellRenderer: ({ cellData }) => (
        <Tooltip content={cellData}>
          <div style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 200 
          }}>
            {cellData}
          </div>
        </Tooltip>
      ),
    },
    {
      key: 'version',
      dataKey: 'version',
      title: t('Version'),
      sortable: true,
      minWidth: 200,
      width: 100,
      flexGrow: 1,
      cellRenderer: ({ cellData }) => (
        <Tooltip content={cellData}>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {cellData}
          </div>
        </Tooltip>
      ),
    },
    {
      key: 'applicability',
      dataKey: 'applicability',
      title: t('Applicability'),
      sortable: true,
      minWidth: 200,
      width: 0,
      flexGrow: 1,
      cellRenderer: ({ cellData }) => (
        <Tooltip content={cellData}>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {cellData}
          </div>
        </Tooltip>
      ),
    },
    {
        key: 'status',
        dataKey: 'status',
        title: t('Status'),
        sortable: true,
        minWidth: 150,
        width: 0,
        flexGrow: 1,cellRenderer: ({ cellData }) => (
          <Lozenge
            isBold={false}
            appearance={statusMap[cellData] ?? "removed"}
          >
            <p>{cellData}</p>
          </Lozenge>
        ),
    },
]);
class FirmwaresPage extends Component {
  componentDidMount() {
  }

  render() {
    const {
      firmwaresData,
      fetching,
      totalPages,
      fetchFirmwares,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;


    return (
      <PageWithTable
        actionButton={{
          title: t('Create Firmware'),
          href: '/firmwares/new',
        }}
        filters={[
          {
            keyName: 'applicabilities',
            placeholder: t('applicabilities'),
            data: dictionaries.applicabilities.data,
            fetching: dictionaries.applicabilities.fetching,
            getData: getDictionaries('applicabilities'),
          }
        ]}
        dataColumns={columns(t)}
        data={firmwaresData}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={fetchFirmwares}
        {...this.props}
        
        permissions={permissions} // TODO: ПРАВА
      />
    );
  }
}

const mapStateToProps = state => ({
  
  permissions: state.userProfile.permissions.firmware,
  firmwaresData: state.firmwares.data,
  totalPages: state.firmwares.totalPages,
  fetching: state.firmwares.fetching,
  dictionaries: state.dictionaries,
});

const mapDispatchToProps = dispatch => ({
    fetchFirmwares: params => dispatch(FirmwaresActions.firmwaresRequest(params)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
});

export default withTranslation('fota')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(FirmwaresPage));
